import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { ShieldCheck, LogOut, LayoutDashboard, Users, Settings as SettingsIcon, Inbox, CheckCircle2, Shield, Flame } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Tableau de bord", Icon: LayoutDashboard, end: true },
  { to: "/admin/inbox", label: "À valider", Icon: Inbox },
  { to: "/admin/ready", label: "Prêts à envoyer", Icon: CheckCircle2 },
  { to: "/admin/prospects", label: "Tous les prospects", Icon: Users },
  { to: "/admin/leads-maurice", label: "Leads Maurice 🇲🇺", Icon: Flame },
  { to: "/admin/settings", label: "Réglages", Icon: SettingsIcon },
  { to: "/admin/security", label: "Sécurité", Icon: Shield },
];

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#050507] text-white flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#08080B] hidden md:flex flex-col">
        <div className="px-6 py-6 border-b border-white/5">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#E52431] to-[#1F2C6E] flex items-center justify-center">
              <ShieldCheck size={16} className="text-white" />
            </div>
            <div>
              <div className="text-[10px] tracking-[2px] text-white/40 font-semibold">EM GROUP</div>
              <div className="text-sm font-semibold">Prospection</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(({ to, label, Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${to.replace("/admin", "").replace("/", "") || "dashboard"}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition ${
                  isActive
                    ? "bg-white/8 text-white"
                    : "text-white/55 hover:text-white hover:bg-white/[0.04]"
                }`
              }
            >
              <Icon size={15} strokeWidth={1.8} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 pb-4 border-t border-white/5 pt-4">
          <div className="px-3 py-2 text-xs text-white/40 truncate">
            {user?.email}
          </div>
          <button
            onClick={handleLogout}
            data-testid="admin-logout"
            className="mt-1 w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/55 hover:text-white hover:bg-white/[0.04] transition"
          >
            <LogOut size={15} strokeWidth={1.8} />
            Déconnexion
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-[#08080B] border-b border-white/10 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-gradient-to-br from-[#E52431] to-[#1F2C6E]" />
          <span className="text-sm font-semibold">Prospection</span>
        </div>
        <button onClick={handleLogout} className="text-white/55 hover:text-white" data-testid="admin-logout-mobile">
          <LogOut size={16} />
        </button>
      </div>

      <main className="flex-1 min-w-0 md:pl-0 pt-14 md:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
